import axios from "@/libs/api.request";
// 获取列表
export const getCities = params => {
  return axios.request({
    url: "/tracker/cities",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/tracker/cities",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = params => {
  return axios.request({
    url: `/tracker/cities/${params.id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/tracker/cities/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = data => {
  return axios.request({
    url: `/tracker/cities/${data.id}`,
    method: "DELETE"
  });
};
